import { jwtDecode } from 'jwt-decode';

export function tokenUserId(token: string) {
  return jwtDecode(token).sub?.replace('USER|', '') || null;
}
